import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { generate } from "utils/ep3util";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(10),
    padding: 0,
  },
  imageContainer: {
    width: "65px",
    height: "65px",
  },
}));

function DataSelfieLegend(props) {
  const classes = useStyles();
  const [questions, setQuestions] = useState();
  useEffect(() => {
    const questions = generate();
    setQuestions(questions);
  }, []);

  function checked(question, option) {
    if (!props.response) {
      return false;
    }
    let q = props.response.filter((d) => d.question === question);
    if (q.length > 0) {
      q = q[0];
      if (q.type === "radiogroup") {
        return q.selected === option.label;
      } else if (q.type === "checkbox") {
        return q.options
          .filter((o) => o.checked)
          .map((o) => o.label)
          .includes(option.label);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  return (
    <Container className={classes.root}>
      {props.layout !== "column" && (
        <Grid container spacing={3}>
          {questions &&
            questions
              .filter((d) => d.visualized)
              .map((d, i) => (
                <Grid key={i} item xs={4}>
                  <Box mb={2}>
                    <Typography variant="body1" gutterBottom>
                      Q{i}. {d.question}
                    </Typography>
                  </Box>
                  {d.options.map((option, i) => (
                    <Grid key={i} container spacing={2} alignItems="center">
                      <Grid item xs={4}>
                        <Paper
                          className={classes.imageContainer}
                          style={{
                            border: checked(d.question, option)
                              ? "2px solid black"
                              : undefined,
                          }}
                        >
                          <img
                            src={process.env.PUBLIC_URL + "/" + option.image}
                            width="64px"
                            height="64px"
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="body2" gutterBottom>
                          {checked(d.question, option) ? (
                            <strong>{option.label}</strong>
                          ) : (
                            option.label
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              ))}
        </Grid>
      )}
      {props.layout === "column" && (
        <Grid container spacing={5}>
          {questions &&
            questions
              .filter((d) => d.visualized)
              .map((d, i) => (
                <Grid key={i} item xs={12}>
                  <Box mb={2}>
                    <Typography variant="body1" gutterBottom>
                    <strong>Q{i+1}.</strong> {d.question}
                    </Typography>
                  </Box>
                  {d.options.map((option, i) => (
                    <Grid key={i} container spacing={2} alignItems="center">
                      <Grid item xs={4}>
                        <Paper
                          className={classes.imageContainer}
                          style={{
                            border: checked(d.question, option)
                              ? "2px solid black"
                              : undefined,
                          }}
                        >
                          <img
                            src={process.env.PUBLIC_URL + "/" + option.image}
                            width="64px"
                            height="64px"
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="body2" gutterBottom>
                          {checked(d.question, option) ? (
                            <strong>{option.label}</strong>
                          ) : (
                            option.label
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              ))}
        </Grid>
      )}
    </Container>
  );
}

export default DataSelfieLegend;
